<template>
    <div class="block--small"><!--<alert text="Dit is een test" close></alert>-->

        <form class="form">
            <h3>Inloggen met e-mail en wachtwoord</h3>
            <div class="alert--error" v-if="error !== undefined && error.length > 0">{{error}}</div>
            <br/>
            <div class="form__group">
                <input class="form__input--text" type="email" name='Email' autocomplete="email"
                       placeholder="E-mailadres" v-model="email" required/>
            </div>

            <div class="form__group">
                <input class="form__input--text" type="password" autocomplete="password" name="Wachtwoord"
                       placeholder="Wachtwoord" v-model="password" required/>
            </div>

            <div class="form__buttons">
                <button @click.prevent="login" class="button--cta">Inloggen</button>
            </div>
        </form>

        <div class="link_block">
            <router-link to="register"><strong>Nog geen account?</strong></router-link><br/>
            <router-link to="password/forgotten">Wachtwoord vergeten?</router-link>
        </div>

        <div class="link_block">
            <button class="button--cta" @click.prevent="google">Google</button>
            <button class="button--cta" @click.prevent="facebook">Facebook</button>
        </div>

        <div class="loading" v-if="loading">
            <div class="spinner" style="top: 40%;"></div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import firebase from 'firebase';
    import Alert from '@/components/alerts/Alert';
//    import RouterLink from 'vue-router';

    @Component
    export default class LoginForm extends Vue {
        name = 'login-form';

        email = '';

        password = '';

        error = '';

        loading = false;
//
//        changeAuthView(value, event) {
//            this.$emit('changeAuthComponent', value);
//        }

        created() {

        }

        login() {
            this.error = '';
            this.loading = true;

            console.log('Login', 'New login try', this.email, this.password);
            firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(() => {
                this.loading = false;
//                this.$router.go('/');

                var redirect = this.$route.query.redirect;
                if (redirect) {
                    this.$router.replace(redirect);
                } else {
                    this.$router.replace({
                        name: 'markets'
                    });
                }
            }).catch((error) => {
                let errorCode = error.code;
                let errorMessage = error.message;

                this.loading = false;

                switch (errorCode) {
                case 'auth/invalid-email':
                    this.error = 'Dit e-mailadres is ongeldig.';
                    break;
                case 'auth/user-disabled':
                    this.error = 'Sorry, je account is geblokkeerd door de administrator.';
                    break;
                case 'auth/user-not-found':
                    this.error = 'Er bestaat geen gebruiker met did e-mailadres.';
                    break;
                case 'auth/wrong-password':
                    this.error = 'De gegevens kwamen niet overeen.';
                    break;
                case 'auth/network-request-failed':
                    this.$notify('Kon geen verbinding maken met het internet.');
                    break;
                }

                console.error('Login error', errorCode, errorMessage);

                //auth/user-not-found
                //auth/wrong-password
                //auth/user-disabled
                //auth/too-many-requests
                //auth/network-request-failed
                //auth/account-exists-with-different-credential

                //auth/user-token-expired
                //auth/requires-recent-login
            });
        }

        google() {
            this.loading = true;

            firebase.auth().useDeviceLanguage();
            var provider = new firebase.auth.GoogleAuthProvider();
            firebase.auth().signInWithPopup(provider).then((result) => {
                // This gives you a Google Access Token. You can use it to access the Google API.
                var token = result.credential.accessToken;
                // The signed-in user info.
                var user = result.user;

                this.loading = false;
                console.log('Signed In', user);
//                this.$router.go('/');

                var redirect = this.$route.query.redirect;
                if (redirect) {
                    this.$router.replace(redirect);
                } else {
                    this.$router.replace({
                        name: 'markets'
                    });
                }
            }).catch((error) => {
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                // The email of the user's account used.
                var email = error.email;
                // The firebase.auth.AuthCredential type that was used.
                var credential = error.credential;
                // ...

                this.loading = false;
                console.log('Sign in error', errorCode, errorMessage, email);
            });
        }

        facebook() {
            this.loading = true;

            firebase.auth().useDeviceLanguage();
            var provider = new firebase.auth.FacebookAuthProvider();
            firebase.auth().signInWithPopup(provider).then((result) => {
                // This gives you a Google Access Token. You can use it to access the Google API.
                var token = result.credential.accessToken;
                // The signed-in user info.
                var user = result.user;

                this.loading = false;
                console.log('Signed In', user);
//                this.$router.go('/');

                var redirect = this.$route.query.redirect;
                if (redirect) {
                    this.$router.replace(redirect);
                } else {
                    this.$router.replace({
                        name: 'markets'
                    });
                }

            }).catch((error) => {
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                // The email of the user's account used.
                var email = error.email;
                // The firebase.auth.AuthCredential type that was used.
                var credential = error.credential;
                // ...

                this.loading = false;
                console.log('Sign in error', errorCode, errorMessage, email);
            });
        }
    }

    Vue.component(LoginForm.name, LoginForm);
</script>



// WEBPACK FOOTER //
// src/components/auth/forms/LoginForm.vue